export default (state = [], action) => {
  switch (action.type) {
    case 'ADD_PRODUCT':
      return [ ...state, ...action.payload ] || false
    default:
      return state
  }
}